import { Button, Card, Col, Form, Input, Row, Table, Typography } from "antd";

import dayjs from "dayjs";
import React, { Fragment, useEffect, useState } from "react";
import { CSVLink } from "react-csv";
import { toast } from "react-toastify";
import ViewBtn from "../Buttons/ViewBtn";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";
import ColVisibilityDropdown from "../Shared/ColVisibilityDropdown";
import { CsvLinkBtn } from "../UI/CsvLinkBtn";
import { addDepartment, getDepartments } from "./departmentApis";

function CustomTable({ list }) {
	const [columnsToShow, setColumnsToShow] = useState([]);

	const columns = [
		{
			id: 1,
			title: "S.No",
			dataIndex: "serial",
			key: "serial",
		},
		{
			id: 2,
			title: "Name",
			dataIndex: "name",
			key: "name",
		},

		{
			id: 3,
			title: "Created at",
			dataIndex: "createdAt",
			key: "addrcreatedAtess",
			render: (createdAt) => dayjs(createdAt).format("YYYY-MM-DD"),
		},
		{
			id: 4,
			title: "Action",
			dataIndex: "id",
			key: "action",
			render: (id) => <ViewBtn path={`/admin/department/${id}/`} />,
		},
	];

	useEffect(() => {
		setColumnsToShow(columns);
	}, []);

	const columnsToShowHandler = (val) => {
		setColumnsToShow(val);
	};

	// const addKeys = (arr) => arr.map((i) => ({ ...i, key: i.id }));
	const addKeys = (arr) => arr.map((i, index) => ({ ...i, key: i.id, serial: index + 1 }));
	const flattenData = (data) => {
		return data.map(item => ({
			id: item.id,
			company_id: item.company_id,
			name: item.name,
			status: item.status,
			user: Array.isArray(item.user)
				? item.user
					.map(u => `${u.firstName || ''} ${u.lastName || ''}`.trim())
					.join(", ")
				: "No Users",
		}));
	};


	return (
		<Card>
			<div className='text-center my-2 flex justify-between'>
				<h5 className='department-list-title text-color-2 text-xl mb-2'>
					Department List
				</h5>
				{list && (
					<div>
						<CsvLinkBtn>
							<CSVLink
								data={flattenData(list)}
								className='btn btn-dark btn-sm mb-1'
								filename='departments'>
								Download CSV
							</CSVLink>
						</CsvLinkBtn>
					</div>
				)}
			</div>

			{list && (
				<div style={{ marginBottom: "30px" }}>
					<ColVisibilityDropdown
						options={columns}
						columns={columns}
						columnsToShowHandler={columnsToShowHandler}
					/>
				</div>
			)}

			<Table
				scroll={{ x: true }}
				loading={!list}
				columns={columnsToShow}
				dataSource={list ? addKeys(list) : []}
			/>
		</Card>
	);
}
const AddDepartment = ({ drawer }) => {
	const [list, setList] = useState(null);
	const [loader, setLoader] = useState(false);
	const [form] = Form.useForm(); // Create form instance

	useEffect(() => {
		getDepartments()
			.then((d) => setList(d))
			.catch((error) => console.log(error));
	}, []);

	const { Title } = Typography;

	const onFinish = async (values) => {
		setLoader(true);
		try {
			const resp = await addDepartment(values);

			if (resp.message === "success") {
				const newList = list ? [...list] : [];
				newList.push(resp.data);
				setList(newList);

				// Reset form
				form.resetFields();

				// Show success message
				toast.success("Department added successfully!");
			}
		} catch (error) {
			toast.error("Failed to add department");
		} finally {
			setLoader(false);
		}
	};

	const onFinishFailed = (errorInfo) => {
		toast.warning("Failed at adding department");
		setLoader(false);
	};

	// Add manual reset handler for the button
	const handleReset = () => {
		form.resetFields();
	};

	return (
		<Fragment>
  <UserPrivateComponent permission={"create-department"}>
    <Row className="mr-top" gutter={[16, 16]} justify="space-between">
      {/* Left Column: Add Department Form */}
      <Col xs={24} sm={24} md={10} lg={10} xl={8} className="column-design border rounded card-custom">
        <Title level={4} className="m-2 mt-5 mb-5 text-center">
          Add Department
        </Title>
        <Form
          form={form}
          style={{ marginBottom: "40px" }}
          name="department-form"
          labelCol={{ span: 6 }}
          wrapperCol={{ span: 16 }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          preserve={false}
        >
          <Form.Item
            label="Name"
            name="name"
            rules={[{ required: true, message: "Please input department name!" }]}
          >
            <Input />
          </Form.Item>

          <Form.Item wrapperCol={{ offset: 6, span: 16 }}>
            <Button type="primary" size="large" htmlType="submit" block loading={loader}>
              Add New Department
            </Button>
          </Form.Item>
        </Form>
      </Col>

      {/* Right Column: Department List Table */}
      <Col xs={24} sm={24} md={14} lg={14} xl={16}>
        <CustomTable list={list} />
      </Col>
    </Row>
  </UserPrivateComponent>
</Fragment>

	);
};

export default AddDepartment;